'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface SurveyErrorPageProps {
  statusCode: string;
  title: string;
  message: string;
}

export function SurveyErrorPage({ statusCode, title, message }: SurveyErrorPageProps) {
  const router = useRouter();

  return (
    <main className="survey-error-shell">
      <section className="survey-error-card" aria-labelledby="survey-error-title">
        <div className="survey-error-badge">{statusCode}</div>
        <h1 id="survey-error-title">{title}</h1>
        <p>{message}</p>
        <div className="survey-error-actions">
          <Link href="/" className="survey-error-primary">
            Home
          </Link>
          <button type="button" className="survey-error-secondary" onClick={() => router.back()}>
            Go Back
          </button>
        </div>
      </section>
    </main>
  );
}
